import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

/**
 * Handles display of dump card
 */
@Component({
	selector: 'app-dump-card',
	templateUrl: './dump-card.component.html'
})
export class DumpCardComponent implements OnInit {
	@Input() public isLoading: boolean = false;
	@Input() public categoryType: string = '';

	public ngOnInit(): void {
		if (!this.categoryType) {
			return;
		}
	}
}
